import module from 'module';

const templateUrl = require('./gl-header.template.html');
module.component('glHeader', {
  templateUrl,
  transclude: true
});
